import { render, staticRenderFns } from "./xjCheck.vue?vue&type=template&id=697c2a5a&"
import script from "./xjCheck.vue?vue&type=script&lang=js&"
export * from "./xjCheck.vue?vue&type=script&lang=js&"
import style0 from "./xjCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports